import { defaultLocale } from '@adsk/alloy-react-locale';

// ts supports Locale, but not the weekInfo property yet, not even in ESNEXT

export const LOCALE_TO_FIRST_DAY_OF_WEEK = {
  'fr-CA': 0,
  da: 1,
  es: 1,
  fi: 1,
  ru: 1,
  'zh-Hans': 1,
  hr: 1,
  fr: 1,
  nl: 1,
  ja: 0,
  ca: 1,
  hu: 1,
  it: 1,
  pl: 1,
  cs: 1,
  'pt-BR': 0,
  'en-GB': 1,
  de: 1,
  ro: 1,
  'zh-Hant': 0,
  ko: 0,
  tr: 1,
  'pt-PT': 0,
  en: 0,
  [defaultLocale]: 0,
  sv: 1,
  no: 1,
  'zh-Hant-HK': 0
};

// 7 and 0 are equivalent for Sunday as first day of week, the Intl api uses 7, but we
// prefer to always use 0
const clamp = function () {
  let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return num >= 7 ? 0 : num;
};

// Intl.Locale.WeekInfo has partial support in browsers, the Locale polyfill from @formatjs
// doesn't polyfill the property we need.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
//   /Locale/weekInfo#browser_compatibility
const getFirstDayOfWeek = (locale, firstDayOfWeekProp) => {
  if (typeof firstDayOfWeekProp === 'number') return clamp(firstDayOfWeekProp);
  try {
    var _weekInfo$firstDay;
    const {
      weekInfo
    } = new Intl.Locale(locale || defaultLocale);
    return clamp((_weekInfo$firstDay = weekInfo === null || weekInfo === void 0 ? void 0 : weekInfo.firstDay) !== null && _weekInfo$firstDay !== void 0 ? _weekInfo$firstDay : LOCALE_TO_FIRST_DAY_OF_WEEK[locale || defaultLocale]);
  } catch (e) {
    return clamp(LOCALE_TO_FIRST_DAY_OF_WEEK[locale || defaultLocale]);
  }
};
export default getFirstDayOfWeek;
//# sourceMappingURL=getFirstDayOfWeek.js.map